/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/mobile_medium'
export default icon
